/**
 * TMR EPC
 *
 * @type {ngService}
 */
export class TmrEpc {
  static ngType = 'service'

  constructor(TmrApi) {
    'ngInject'
    Object.assign(this, { TmrApi })
  }

  encode(upc, serial, partition) {
    return this.TmrApi.get('epc.encode', null, {
      params: { upc, serial, partition },
    }).then(res => res.data.value)
  }

  decode(epc) {
    return this.TmrApi.get('epc.decode', null, { params: { epc } }).then(
      res => res.data
    )
  }

  /**
   * @param {string} product.code
   */
  getNextSerial({ code }) {
    return this.TmrApi.get('serial.nextValue', null, { params: { code } }).then(
      res => res.data.value
    )
  }
}
